import { getPartitionNumber as getPartitionNumberFromCommon } from '@shipstation/client-common/utils/partition';
import { LogService } from './log-service';

/**
 * Returns the partition identifier for the current environment.
 * @returns {number | string} partition id
 */
export const getPartitionNumber = () => getPartitionNumberFromCommon();

/**
 * Converts a partition number to its alphabetical representation.
 * This function uses the current partition number from getPartitionNumber()
 * and converts it to a letter representation for use in metadata.
 * @returns {string} The alphabetical partition representation:
 *   - 'Z' for partition number 0
 *   - 'Y' for partition number 1
 *   - 'B' for partition number 2
 *   - 'C' for partition number 3, and so on
 *   - 'error determining partition' if an error occurs during conversion
 */
export const getAlphabeticalPartition = () => {
  try {
    const partitionNumber = getPartitionNumber();

    // Handle invalid partition numbers
    if (typeof partitionNumber !== 'number' || Number.isNaN(partitionNumber)) {
      throw new Error('Invalid partition number');
    }

    // Special mappings:
    // 0 maps to 'Z'
    if (partitionNumber === 0) {
      return 'Z';
    }

    // 1 maps to 'Y'
    if (partitionNumber === 1) {
      return 'Y';
    }

    // For numbers 2 and above:
    // 2 maps to 'B' (ASCII 66)
    // 3 maps to 'C' (ASCII 67)
    // etc.
    return String.fromCharCode(partitionNumber + 64);
  } catch (error) {
    LogService.logInfo('Error determining alphabetical partition', {
      error: error.message,
    });
    return 'error determining partition';
  }
};
